module.exports = __webpack_public_path__ + "media/images/flags/16/Saint-Helena-ad0588a6b5d69ae45f13ea929e309514.png";